var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"context-menu-header-flashy"},[_c('Row',[_c('Column',[_c('div',{staticClass:"large-header",class:{'large-header--is-floating': _vm.isFloating}},[_vm._t("default")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }